import generateFrontUri from "@raiden/library/libraries/utils/generateFrontUrl";
import { useIntl } from "react-intl";
import Seo from "..";

function DefaultSeo() {
  const intl = useIntl();

  return (
    <Seo
      title={intl.formatMessage({
        defaultMessage: "Site officiel de la Mairie de La Bresse",
      })}
      description={intl.formatMessage({
        defaultMessage:
          "Bienvenue à La Bresse, commune touristique de 4500 habitants au coeur des Hautes-Vosges. Démarches, formalités, documents téléchargeables, actualités, événements, associations, ...",
      })}
      imageUrl={generateFrontUri({
        id: "@front.internal-assets",
        parameters: {
          filePath: "logo.svg",
        },
        includeBasePath: true,
      })}
    />
  );
}

export default DefaultSeo;
